import type { INotification } from "@bbj-types/notification";
import {
  type IWebsocketBody,
  type IWebsocketBodyDocument,
  WebsocketChannelNotificationActions,
  WebsocketChannels,
} from "@bbj-types/websockets/body";
import type { WebsocketSendActions } from "@bbj-types/websockets/subscribe";
import { manageHandlerWebsocket } from "@root/utils/websocket";
import { handleWebsocket } from "@styleguide";
import type { Dispatch, SetStateAction } from "react";
import type { WebsocketClient } from "./WebsocketClient";

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

const handleUpdateDocument = (body: IWebsocketBodyDocument) => {
  const document = body.message;
  if (document.uploaded) {
    window.publish("feedback", {
      severity: "success",
      message: `Le document ${document.name} a bien été vérifié puis importé.`,
    });
    return;
  }
  window.publish("feedback", {
    severity: "error",
    message: `Le document ${document.name} n’a pas pu être importé en raison de l’échec de l’analyse antivirus.`,
  });
};

const handleNotification = (setNotifications: Dispatch<SetStateAction<INotification[]>>) => (body: IWebsocketBody) => {
  switch (body.action) {
    case WebsocketChannelNotificationActions.NEW_NOTIFICATION:
      setNotifications((n) => [...n, body.message]);
      break;
  }
};

export const handleMessage = (setHasHiring: Dispatch<SetStateAction<boolean>>) => (message: MessageEvent["data"]) => {
  const data = typeof message === "string" ? JSON.parse(message) : message;
  switch (data?.channel) {
    case "event":
      if (data.action === "candidate:hired:new") {
        setHasHiring(true);
        setTimeout(() => setHasHiring(false), 10 * 1000);
      } else if (data.action === "user:sms:new") {
        window.publish("get:navbar:notification", { message: "", severity: "info" });
      }
      break;
    default:
      handleWebsocket(data);
      break;
  }
};
export const manageGlobalSubscriptions =
  (
    wsClient: WebsocketClient,
    setNotifications: Dispatch<SetStateAction<INotification[]>>,
    action: WebsocketSendActions.SUBSCRIBE | WebsocketSendActions.UNSUBSCRIBE
  ) =>
  async () => {
    wsClient.sendJson({
      action: "subscribeChannel",
      channel: "event",
    });
    await sleep(300);
    manageHandlerWebsocket(
      WebsocketChannels.NOTIFICATION,
      handleNotification(setNotifications),
      "notification",
      action
    );
    await sleep(300);
    manageHandlerWebsocket(WebsocketChannels.DOCUMENT, handleUpdateDocument, "document", action);
  };
